import posthog from "posthog-js";

let initialized = false;

type InitOptions = {
  apiKey: string;
  apiHost?: string;
  globalProperties?: Record<string, unknown>;
  debug?: boolean;
};

export function initAnalytics(opts: InitOptions): void {
  if (initialized || typeof window === "undefined") return;

  posthog.init(opts.apiKey, {
    api_host: opts.apiHost || "https://eu.i.posthog.com",
    capture_pageview: false, // drawer is a one-page widget; events are manual
    persistence: "localStorage",
    autocapture: false,
    loaded: (ph) => {
      if (opts.debug) ph.debug();
      if (opts.globalProperties) ph.register(opts.globalProperties);
    },
  });
  initialized = true;
}

export function track(
  event: string,
  props?: Record<string, unknown>,
): void {
  if (!initialized) return;
  posthog.capture(event, props);
}

export function identify(
  distinctId: string,
  props?: Record<string, unknown>,
): void {
  if (!initialized) return;
  posthog.identify(distinctId, props);
}
